import React from "react";
import styled from "styled-components";

const hr_styles = (theme) => `
    height: 50px;
    width: 100px;
    display: block;
    margin: 20px auto;
    background-image: url('./static/squiggly.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: white;
    border: 0;
`;

// @media(min-width:${theme.breakpoints.lg}) {
//     display: none;
// }

const image_styles = (theme) => `
    margin: 0 auto;
    display:block;
    padding-top:20px;
    width:100%;
    height:auto;
`;

const image_caption_styles = (theme) => `
    text-align:left;
    @media(min-width:${theme.breakpoints.lg}) {
        text-align:center;
    }
    line-height: 18px;
    margin-top: 10px;
    font-size:12px;
    color:#727272;
`;

const paragraph_styles = (theme) => `
    font-family: ${theme.fonts.karma};
    font-size: 20px;
    line-height: 28px;
    margin:20px 0 30px;
`;

const HtmlContainer = styled.div.attrs({ className: "w-full px-6 pb-8" })`
  ${({ theme }) => `

            * {
                font-family: ${theme.fonts.karma}
            }

            p {
                ${paragraph_styles(theme)}
            }
            a {
                color: ${theme.colors.orange}
            }
            img {
                ${image_styles(theme)}
            }
            .image-caption {
                ${image_caption_styles(theme)}
            }
            hr {
                 ${hr_styles(theme)}
            }
            h1 {
              font-size: 2em;
              font-weight: 700;
              font-family: Poppins, Arial, sans-serif;
            }
            h2 {
              font-size: 1.5em;
              font-weight: 600;
              font-family: Poppins, Arial, sans-serif;
            }
            h3 {
              font-size: 1.25em;
              font-weight: 500;
              font-family: Poppins, Arial, sans-serif;
            }
            blockquote > p {
              font-size: 1.75em;
              font-weight: 500;
              font-family: Poppins, Arial, sans-serif;
              color: #FF584A;
              text-align: center;
            }
    `}
`;

export default function StoryBodyHtml({ html }) {
  return <HtmlContainer dangerouslySetInnerHTML={{ __html: html }} />;
}
